import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { GenerateBlogSummaryArgs } from '@ztechapps/common.contract'
import { generateBlogSummaryMutation } from '../graphql/generateBlogSummary'

const defaultQuery = generateBlogSummaryMutation

/**
 * Hook to generate blog summary using AI
 *
 * @example
 * ```tsx
 * const [generateSummary, , { loading, error }] = useGenerateBlogSummary()
 *
 * const handleGenerate = async () => {
 *   const result = await generateSummary({ input: { blogId: 'blog-123' } })
 *   const summary = result?.data?.generateBlogSummary ?? ''
 * }
 * ```
 */
export type UseGenerateBlogSummaryResult = ReturnType<
  typeof useMutation<{ generateBlogSummary: string }, GenerateBlogSummaryArgs>
>

export const useGenerateBlogSummary = (
  { query: queryProp, ...props } = {} as UseMutationProps
): UseGenerateBlogSummaryResult => {
  const query = queryProp ?? defaultQuery
  return useMutation<{ generateBlogSummary: string }, GenerateBlogSummaryArgs>({ query, ...props })
}
